<template>
  <v-checkbox
    v-if="!readonly"
    v-model="checkboxValue"
    v-bind="customData.props"
    :class="customClasses"
    :disabled="disabled"
    v-on="$listeners"
  >
    <slot />
  </v-checkbox>
  <w-read-only-text-field
    v-else
    :label="$props.label"
    :value="inputValueString"
    :pending="$props.pending"
    :class="customClasses"
    v-on="$listeners"
  >
    <slot />
  </w-read-only-text-field>
</template>

<script>
import { VCheckbox } from "vuetify/lib";
import isRequired from "@/mixins/component/is-required-mixin";
import pendingAble from "@/mixins/component/pending-able-mixin";
import { getRequiredLabelProp } from '@/components/global_components/forms/utils/required-label-util';

export default {
  name: "WorkCheckbox",
  mixins: [isRequired, pendingAble],
  props: {
    isFilter: { type: Boolean, default: false },
    option: { type: Boolean, required: false },
    disabled: { type: Boolean, default: false },
    ...VCheckbox.options.props,
  },
  computed: {
    checkboxValue: {
      get() {
        return this.$props.value ?? this.$props.inputValue;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    inputValueString() {
      return this.checkboxValue === true ? this.$t('Common.yes') : this.checkboxValue === false ? this.$t('Common.no') : '';
    },
    customClasses() {
      return [
        'w-checkbox--input',
        { 'w-checkbox--input--has-label': this.label },
        { 'w-checkbox--option': this.$props.option },
        { 'w-checkbox--filter': this.$props.isFilter }
      ]
    },
    customData() {
      return {
        props: {
          hideDetails: 'auto',
          type: 'checkbox',
          indeterminate: this.checkboxValue === undefined || this.checkboxValue === null,
          offIcon: this.offIcon,
          ...getRequiredLabelProp(this.$props),
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-input--checkbox svg {
  @include w-checkbox;
}

.w-checkbox {

  &--input {
    margin-top: 0;
    padding-top: 0;

    ::v-deep .v-input__slot>.v-label {
      @include w-p4;
    }
  }

  &--option {
    & .v-input__slot>.v-label {
      @include w-p4;
    }
  }

  &--filter {
    .v-input__control {
      position: relative;

      .v-input__slot {
        margin-bottom: 0;
      }

      .v-messages {
        position: absolute;
        bottom: -1.25rem;
      }
    }
  }
}
</style>
